import { Injectable } from '@angular/core';
import { PersonSearchResult } from '../models/PH3A/person/person-search';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ScoreRegistration } from '../models/PH3A/score/score-registration';
import { CompanySearchResult } from '../models/PH3A/company/company-search';
import { timeout } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class PH3AService {
  constructor(private http: HttpClient) { }

  getPersonData(cpf: string): Observable<PersonSearchResult> {
    if (!environment.enablePh3aIntegration) {
      const result: PersonSearchResult = null;
      return of(result);
    }
    const url = `${environment.ph3aSettings.url}${environment.ph3aSettings.ph3aGetPersonData}/${cpf}`;
    return this.http.get<PersonSearchResult>(url).pipe(timeout(2000));
  }

  getCompanyData(cnpj: string): Observable<CompanySearchResult> {
    if (!environment.enablePh3aIntegration) {
      const result: CompanySearchResult = null;
      return of(result);
    }
    const url = `${environment.ph3aSettings.url}${environment.ph3aSettings.ph3aGetCompanyData}/${cnpj}`;
    return this.http.get<CompanySearchResult>(url).pipe(timeout(2000));
  }

  getDocumentScore(document: string): Observable<ScoreRegistration> {
    if (!environment.enablePh3aIntegration) {
      const result: ScoreRegistration = null;
      return of(result);
    }
    const url = `${environment.ph3aSettings.url}${environment.ph3aSettings.scoreRegistration}/${document}`;
    return this.http.get<ScoreRegistration>(url, {}).pipe(timeout(2000));
  }
}
